import MigrationConciergeFloat from './MigrationConciergeFloat';
import { SALES_CRUNCHY } from './crunchyConfigs';

/**
 * Floating "Ask Crunchy" salesperson for SalesCrunchCRM marketing pages
 * (homepage, /pricing, /affiliates). Talks to POST /api/ai/crm/chat-anon —
 * ROI math, migration quotes, competitor comparisons, and warm-lead capture.
 */
export default function SalesConciergeFloat() {
  return <MigrationConciergeFloat cfg={SALES_CRUNCHY} />;
}
